module.exports = __webpack_public_path__ + "img/areaBlueBusiness.8954b15c.png";